import { GENRE_LIBRARY } from '../data/GenreLibrary';

/**
 * MixerStrategies.js
 * Logic for determining global mixing parameters based on musical context.
 */

/**
 * Derives a full mixer configuration from a genre definition.
 * @param {string|Object} genre - Genre key (e.g., 'orchestra') or genre definition object.
 * @returns {Object} Mixer Configuration { masterBus, globalReverb, globalDelay }
 */
export const applyAutoMix = (genre) => {
    let profile = null;

    // Resolve genre profile
    if (typeof genre === 'string') {
        const key = genre.toLowerCase();
        // Check main genres
        if (GENRE_LIBRARY[key] && GENRE_LIBRARY[key].defaults) {
            profile = GENRE_LIBRARY[key].defaults.mixProfile;
        }

        if (!profile) {
            // Try to find in subgenres (scan all main genres)
            Object.values(GENRE_LIBRARY).some(main => {
                if (main.subGenres && main.subGenres[key]) {
                    // Subgenres inherit from main defaults if they don't have their own override
                    // (Currently I only added mixProfile to main defaults, so this is the correct fallback)
                    profile = main.subGenres[key].mixProfile || main.defaults.mixProfile;
                    return true;
                }
                return false;
            });
        }
    } else if (genre && typeof genre === 'object') {
        // Handle object input (composition.genre might be the full object)
        if (genre.mixProfile) {
            profile = genre.mixProfile;
        } else if (genre.defaults && genre.defaults.mixProfile) {
            profile = genre.defaults.mixProfile;
        }
    }

    // Default Profile if nothing found (Fail-safe)
    if (!profile) {
        // console.warn(`[MixerStrategies] No mix profile found for genre: ${genre}. Using Default.`);
        return {
            masterBus: {
                compression: { threshold: -10, ratio: 2, attack: 0.05, release: 0.1 },
                eq: { low: 0, mid: 0, high: 0 },
                width: 0.5
            },
            globalReverb: { type: 'room', decay: 1.5, preDelay: 0.01, wet: 0.2 },
            globalDelay: { delayTime: 0.3, feedback: 0.3, wet: 0.1 }
        };
    }

    return profile;
};
